export default "__VITE_PUBLIC_ASSET__d06ea1be__"